<template>
    <div>
        <h4>{{answer.content.subtitle}}</h4>
        
        <div class="textDiv">
            {{answer.content.text}}
        </div>
        <div class="buttonDiv">
          <div v-if="answer.showExpanded">
            <a @click="returnClicked($event)" class="btn returnBtn">Return</a>
          </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";

export default {
  name: "TextCard",
  props: ["answer"],
  methods: {
    returnClicked(event) {
      this.$emit('returnClickedText', event);
    }
  }
};
</script>

<style scoped>
.textDiv {
  margin: 10px 0;
}

.buttonDiv {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  margin-right: -3%;
  margin-left: -3%;
  margin-bottom: -1.5%;
}

.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.6rem 0.75rem;
  font-size: .8rem;
  line-height: 1.5;
  border-radius: 10px;
  color: #fff;
  background-color:#195a9a;
  text-decoration: none;
  cursor: pointer;
}

.returnBtn {
  background-color: #2e4c30;
}
</style>

